import {Component, input} from '@angular/core';
import {InputIcon} from 'primeng/inputicon';
import {IconField} from 'primeng/iconfield';
import {InputText} from 'primeng/inputtext';
import {TranslatePipe} from '@ngx-translate/core';
import {FormControl, ReactiveFormsModule} from '@angular/forms';

@Component({
  selector: 'elcia-search',
  imports: [
    InputIcon,
    IconField,
    InputText,
    TranslatePipe,
    ReactiveFormsModule
  ],
  templateUrl: './search.html',
  styleUrl: './search.scss',
})
export class Search {
  control = input.required<FormControl<string>>();
}
